// Backend integration point: replace with real DB queries filtered by usuario_id

export type Rol = 'admin' | 'socio';

export interface Usuario {
  id: string;
  nombre: string;
  correo: string;
  contrasena: string;
  rol: Rol;
  estado: 'activo' | 'inactivo';
}

export interface ConfiguracionSocio {
  usuario_id: string;
  dias_por_anio: number;
  dias_usados: number;
  minimo_por_solicitud: number;
  anio: number;
}

export interface Pago {
  id: string;
  usuario_id: string;
  monto: number;
  fecha: string;
  concepto: string;
  creado_por: string;
}

export interface EstadoCuenta {
  usuario_id: string;
  al_dia: boolean;
  saldo_pendiente: number;
}

export interface Reserva {
  id: string;
  usuario_id: string;
  fecha_inicio: string;
  fecha_fin: string;
  dias: number;
  estado: 'pendiente' | 'aprobada' | 'rechazada' | 'bloqueada';
  aprobada_por?: string;
  notas?: string;
}

export interface SolicitudDiasAdicionales {
  id: string;
  usuario_id: string;
  dias_solicitados: number;
  fechas_propuestas: string;
  motivo: string;
  estado: 'pendiente' | 'aprobada' | 'rechazada';
  fecha_solicitud: string;
}

export interface Promocion {
  id: string;
  titulo: string;
  descripcion: string;
  fecha_inicio: string;
  fecha_fin: string;
  porcentaje: number;
  destinatarios: string[];
  enviada_en: string;
}

export interface ImagenLanding {
  id: string;
  url: string;
  alt: string;
  orden: number;
}

export interface Prospecto {
  id: string;
  nombre: string;
  correo: string;
  telefono: string;
  mensaje: string;
  fecha: string;
}

// ─── Usuarios mock ──────────────────────────────────────────────────────────
export const mockUsuarios: Usuario[] = [
{
  id: 'usr-admin-001',
  nombre: 'Alejandro Vargas',
  correo: 'admin@bahiabaliz.cr',
  contrasena: 'Admin2026!',
  rol: 'admin',
  estado: 'activo'
},
{
  id: 'usr-socio-001',
  nombre: 'Carolina Jiménez',
  correo: 'carolina@bahiabaliz.cr',
  contrasena: 'Socio2026!',
  rol: 'socio',
  estado: 'activo'
},
{
  id: 'usr-socio-002',
  nombre: 'Roberto Solís',
  correo: 'roberto@bahiabaliz.cr',
  contrasena: 'Socio2026!',
  rol: 'socio',
  estado: 'activo'
},
{
  id: 'usr-socio-003',
  nombre: 'Marcela Ureña',
  correo: 'marcela@bahiabaliz.cr',
  contrasena: 'Socio2026!',
  rol: 'socio',
  estado: 'activo'
},
{
  id: 'usr-socio-004',
  nombre: 'Diego Montero',
  correo: 'diego@bahiabaliz.cr',
  contrasena: 'Socio2026!',
  rol: 'socio',
  estado: 'inactivo'
}];


// ─── Configuración de socios ─────────────────────────────────────────────────
export const mockConfiguraciones: ConfiguracionSocio[] = [
{ usuario_id: 'usr-socio-001', dias_por_anio: 30, dias_usados: 12, minimo_por_solicitud: 3, anio: 2026 },
{ usuario_id: 'usr-socio-002', dias_por_anio: 20, dias_usados: 20, minimo_por_solicitud: 2, anio: 2026 },
{ usuario_id: 'usr-socio-003', dias_por_anio: 25, dias_usados: 8, minimo_por_solicitud: 4, anio: 2026 },
{ usuario_id: 'usr-socio-004', dias_por_anio: 15, dias_usados: 0, minimo_por_solicitud: 2, anio: 2026 }];


// ─── Pagos mock ───────────────────────────────────────────────────────────────
export const mockPagos: Pago[] = [
{ id: 'pago-001', usuario_id: 'usr-socio-001', monto: 150000, fecha: '2026-01-15', concepto: 'Cuota Enero 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-002', usuario_id: 'usr-socio-001', monto: 150000, fecha: '2026-02-10', concepto: 'Cuota Febrero 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-003', usuario_id: 'usr-socio-001', monto: 150000, fecha: '2026-03-08', concepto: 'Cuota Marzo 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-004', usuario_id: 'usr-socio-001', monto: 150000, fecha: '2026-04-12', concepto: 'Cuota Abril 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-005', usuario_id: 'usr-socio-001', monto: 150000, fecha: '2026-05-09', concepto: 'Cuota Mayo 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-006', usuario_id: 'usr-socio-001', monto: 150000, fecha: '2026-06-14', concepto: 'Cuota Junio 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-007', usuario_id: 'usr-socio-002', monto: 120000, fecha: '2026-01-20', concepto: 'Cuota Enero 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-008', usuario_id: 'usr-socio-002', monto: 120000, fecha: '2026-02-18', concepto: 'Cuota Febrero 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-009', usuario_id: 'usr-socio-002', monto: 120000, fecha: '2026-03-15', concepto: 'Cuota Marzo 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-010', usuario_id: 'usr-socio-003', monto: 135000, fecha: '2026-01-10', concepto: 'Cuota Enero 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-011', usuario_id: 'usr-socio-003', monto: 135000, fecha: '2026-02-12', concepto: 'Cuota Febrero 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-012', usuario_id: 'usr-socio-003', monto: 135000, fecha: '2026-03-11', concepto: 'Cuota Marzo 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-013', usuario_id: 'usr-socio-003', monto: 135000, fecha: '2026-04-09', concepto: 'Cuota Abril 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-014', usuario_id: 'usr-socio-003', monto: 135000, fecha: '2026-05-14', concepto: 'Cuota Mayo 2026', creado_por: 'usr-admin-001' },
{ id: 'pago-015', usuario_id: 'usr-socio-003', monto: 135000, fecha: '2026-06-10', concepto: 'Cuota Junio 2026', creado_por: 'usr-admin-001' }];


// ─── Estados de cuenta ────────────────────────────────────────────────────────
export const mockEstadosCuenta: EstadoCuenta[] = [
{ usuario_id: 'usr-socio-001', al_dia: true, saldo_pendiente: 0 },
{ usuario_id: 'usr-socio-002', al_dia: false, saldo_pendiente: 360000 },
{ usuario_id: 'usr-socio-003', al_dia: true, saldo_pendiente: 0 },
{ usuario_id: 'usr-socio-004', al_dia: false, saldo_pendiente: 450000 }];


// ─── Reservas mock ────────────────────────────────────────────────────────────
export const mockReservas: Reserva[] = [
{ id: 'res-001', usuario_id: 'usr-socio-001', fecha_inicio: '2026-07-20', fecha_fin: '2026-07-26', dias: 6, estado: 'aprobada', aprobada_por: 'usr-admin-001' },
{ id: 'res-002', usuario_id: 'usr-socio-003', fecha_inicio: '2026-08-05', fecha_fin: '2026-08-09', dias: 4, estado: 'pendiente' },
{ id: 'res-003', usuario_id: 'usr-socio-001', fecha_inicio: '2026-09-15', fecha_fin: '2026-09-21', dias: 6, estado: 'pendiente' },
{ id: 'res-004', usuario_id: 'usr-socio-003', fecha_inicio: '2026-07-10', fecha_fin: '2026-07-14', dias: 4, estado: 'aprobada', aprobada_por: 'usr-admin-001' },
{ id: 'res-005', usuario_id: 'usr-socio-002', fecha_inicio: '2026-10-01', fecha_fin: '2026-10-05', dias: 4, estado: 'rechazada', notas: 'Socio con saldo pendiente' },
{ id: 'res-006', usuario_id: 'usr-socio-001', fecha_inicio: '2026-12-26', fecha_fin: '2026-12-31', dias: 5, estado: 'pendiente' },
{ id: 'blk-001', usuario_id: 'usr-admin-001', fecha_inicio: '2026-08-15', fecha_fin: '2026-08-20', dias: 5, estado: 'bloqueada', notas: 'Mantenimiento anual' }];


// ─── Solicitudes días adicionales ─────────────────────────────────────────────
export const mockSolicitudesAdicionales: SolicitudDiasAdicionales[] = [
{ id: 'sol-add-001', usuario_id: 'usr-socio-002', dias_solicitados: 5, fechas_propuestas: '1-5 noviembre 2026', motivo: 'Vacaciones de fin de año con familia', estado: 'pendiente', fecha_solicitud: '2026-07-10' },
{ id: 'sol-add-002', usuario_id: 'usr-socio-001', dias_solicitados: 3, fechas_propuestas: '20-23 diciembre 2026', motivo: 'Navidad con familia extendida', estado: 'aprobada', fecha_solicitud: '2026-06-15' }];


// ─── Promociones mock ─────────────────────────────────────────────────────────
export const mockPromociones: Promocion[] = [
{
  id: 'promo-001',
  titulo: 'Semana Verde — Agosto 2026',
  descripcion: 'Aprovechá la temporada baja con un descuento especial en días de agosto.',
  fecha_inicio: '2026-08-01',
  fecha_fin: '2026-08-31',
  porcentaje: 15,
  destinatarios: ['usr-socio-001', 'usr-socio-003'],
  enviada_en: '2026-07-01'
},
{
  id: 'promo-002',
  titulo: 'Promo Fin de Año',
  descripcion: 'Diciembre con tarifa reducida para todos los socios activos.',
  fecha_inicio: '2026-12-01',
  fecha_fin: '2026-12-31',
  porcentaje: 20,
  destinatarios: ['usr-socio-001', 'usr-socio-002', 'usr-socio-003'],
  enviada_en: '2026-07-05'
}];


// ─── Imágenes landing mock ────────────────────────────────────────────────────
export const mockImagenesLanding: ImagenLanding[] = [
{ id: 'img-001', url: "https://images.unsplash.com/photo-1621097320058-33300706aac0", alt: 'Vista panorámica de piscina infinita frente al océano Pacífico con palmeras', orden: 1 },
{ id: 'img-002', url: "https://img.rocket.new/generatedImages/rocket_gen_img_1294012e5-1770501056157.png", alt: 'Interior moderno de sala de estar con vista al mar y decoración elegante', orden: 2 },
{ id: 'img-003', url: "https://img.rocket.new/generatedImages/rocket_gen_img_13a9d0439-1776260230130.png", alt: 'Habitación principal con cama king size y ventanas panorámicas al jardín tropical', orden: 3 },
{ id: 'img-004', url: "https://images.unsplash.com/photo-1652868965179-691e57c7ea10", alt: 'Terraza con jacuzzi privado rodeada de vegetación tropical al atardecer', orden: 4 },
{ id: 'img-005', url: "https://img.rocket.new/generatedImages/rocket_gen_img_19cba9158-1773093032586.png", alt: 'Cocina equipada moderna con isla central y acabados de lujo', orden: 5 },
{ id: 'img-006', url: "https://img.rocket.new/generatedImages/rocket_gen_img_1f59e7244-1772836359831.png", alt: 'Área de piscina del condominio Pacific Sun con tumbonas y palmeras', orden: 6 }];


// ─── Prospectos mock ──────────────────────────────────────────────────────────
export const mockProspectos: Prospecto[] = [
{ id: 'pros-001', nombre: 'Andrés Brenes', correo: 'abrenes@gmail.com', telefono: '+506 8812-3456', mensaje: 'Me interesa conocer más sobre el modelo de copropiedad. ¿Hay cupos disponibles?', fecha: '2026-07-10' },
{ id: 'pros-002', nombre: 'Silvia Rodríguez', correo: 'silvia.rod@hotmail.com', telefono: '+506 7703-9812', mensaje: 'Vi la propiedad en redes sociales. ¿Cuál es el precio de entrada como socio?', fecha: '2026-07-08' },
{ id: 'pros-003', nombre: 'Fernando Castro', correo: 'fcastro@empresa.cr', telefono: '+506 8901-2345', mensaje: 'Estoy interesado en invertir. ¿Tienen disponibilidad para nuevos accionistas este año?', fecha: '2026-07-05' },
{ id: 'pros-004', nombre: 'Natalia Vega', correo: 'nvega@outlook.com', telefono: '+506 6612-7890', mensaje: 'Me gustaría una visita virtual o tour de la propiedad antes de decidir.', fecha: '2026-07-02' },
{ id: 'pros-005', nombre: 'Carlos Madrigal', correo: 'cmadrigal@gmail.com', telefono: '+506 8234-5678', mensaje: 'Familia de 4 personas buscando propiedad vacacional en Jacó. ¿Cuántos socios son actualmente?', fecha: '2026-06-28' }];


// ─── Helper functions ─────────────────────────────────────────────────────────
export function formatColones(monto: number): string {
  return `₡${monto.toLocaleString('es-CR').replace(/,/g, '.')}`;
}

export function formatFecha(fecha: string): string {
  const [year, month, day] = fecha.split('-');
  return `${day}/${month}/${year}`;
}

export function getNombreSocio(id: string): string {
  const u = mockUsuarios.find((u) => u.id === id);
  return u ? u.nombre : 'Socio desconocido';
}